type AdviserUserLike = {
  display_name?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  fullname?: string | null;
  name?: string | null;
  email?: string | null;
};

function capitalizeWord(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return trimmed;
  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
}

function firstToken(value: string): string | null {
  const token = value.trim().split(/\s+/)[0];
  return token || null;
}

function firstNameFromField(value: string | null | undefined): string | null {
  const token = value ? firstToken(value) : null;
  return token ? capitalizeWord(token) : null;
}

/**
 * Trusted first-name label for greetings.
 * Uses only SSO identity (`first_name`) or the email local-part — never demo
 * `display_name` / `name` fields that may carry the wrong persona.
 * Returns "" when unknown (prefer no name over a wrong one).
 */
export function resolveAdviserPersonaName(user: AdviserUserLike | null | undefined): string {
  const fromFirstName = firstNameFromField(user?.first_name);
  if (fromFirstName) return fromFirstName;

  const email = user?.email?.trim();
  if (email) {
    const local = email.split("@")[0]?.replace(/[._+-]/g, " ").trim();
    const token = local ? firstToken(local) : null;
    if (token) return capitalizeWord(token);
  }

  return "";
}

/** "Good morning, Carl." or "Good morning." when persona name is unknown. */
export function formatAdviserTimeGreeting(
  timeGreeting: string,
  personaName: string | null | undefined,
): string {
  const trimmed = personaName?.trim();
  if (!trimmed) return `${timeGreeting}.`;
  return `${timeGreeting}, ${trimmed}.`;
}
